import { pgEnum } from 'drizzle-orm/pg-core'

export const InvoiceStatusEnum = pgEnum('invoice_status', ['PENDING', 'PAID', 'EXPIRED'])
export type InvoiceStatus = (typeof InvoiceStatusEnum.enumValues)[number]

export const MembershipTypeEnum = pgEnum('membership_type', ['NEW', 'ADD-ON', 'RENEWAL', 'DIRECT_PAID'])
export type MembershipType = (typeof MembershipTypeEnum.enumValues)[number]

/**
 * Provenance of a Premium seat. A seat's window (start/end) is self-contained; `source`
 * records which layer created it. Extensible (future: `direct_purchase`).
 */
export const PremiumSourceEnum = pgEnum('premium_source', ['membership', 'add_on', 'entitlement'])
export type PremiumSource = (typeof PremiumSourceEnum.enumValues)[number]

export const PriceTypeEnum = pgEnum('price_type', ['SCHOOL', 'FAMILY'])
export type PriceType = (typeof PriceTypeEnum.enumValues)[number]

export const VoucherTypeEnum = pgEnum('voucher_type', ['PERCENTAGE', 'VALUE'])
export type VoucherType = (typeof VoucherTypeEnum.enumValues)[number]

/**
 * Which checkout a voucher may be spent on.
 *
 * `CHECKOUT` is a package purchase — NEW and RENEWAL, priced from a rate-card row, which is what
 * `voucher_to_price` narrows. `ADD_ON` is mid-term seats, which have no row of their own: they are
 * priced pro-rata from the pools they join, so a package voucher has nothing to attach to there.
 *
 * The two are deliberately disjoint rather than a flag that widens a voucher: an add-on order is a
 * fraction of a term, and a code written for a full-term purchase would discount far more of it
 * than intended.
 */
export const VoucherScopeEnum = pgEnum('voucher_scope', ['CHECKOUT', 'ADD_ON'])
export type VoucherScope = (typeof VoucherScopeEnum.enumValues)[number]
